export default __webpack_public_path__ + "static/media/2.64ec9144.png";